import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import {
  updateFilter,
  showFilter,
} from "../../../../../../store/actions/filter.actions";
import { useLocation, useNavigate } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import { updateSkip } from "../../../../../../store/actions/datatable.actions";
import DialogConfirmCancel from "../../../../../dialog/DialogConfirm";
import InputField from "../../../../../FormControl/input/InputField";
import { Typography } from "@mui/material";
import SelectField from "../../../../../FormControl/input/SelectField";
import useFetchData from "../../../../../../hooks/useFetchData";
import SelectPeriod from "../../SelectCustom/SelectPeriod";

const FilterDialog = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const filter = useSelector((state) => state?.filter?.periodicalReport?.filter || {});
  const { data: periodData, isLoading: periodisLoading, error: periodError } = useFetchData('periodical-report/setting/period');
  const open = useSelector((state) => state?.filter?.periodicalReport?.open || false);

  const dispatch = useDispatch();

  const [form, setInputForm] = useState(filter);

  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter);
    }
  }, [filter]);

  const onClose = () => {
    dispatch(showFilter('periodicalReport', false));
  };
  const onChange = (key, value = "") => {
    if (key === "period") {
      const period = periodData?.find((item) => item._id === value);
      setInputForm({ ...form,periodId: value || null, period: period?.name });
    } else {
      setInputForm({ ...form, [key]: value });
    }
  };

  const onApply = () => {
    onClose();
    const filter = {
      ...form,
    };
    dispatch(updateFilter('periodicalReport', filter));
    dispatch(updateSkip('periodicalReport', 0));
    navigate(pathname, { state: filter });
  };


  return (
    <DialogConfirmCancel
      id="dr-filter"
      open={open}
      title="Filter"
      maxWidth="xs"
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm="Apply"
    >
      <Box className="grid grid-cols-4 gap-4">
        <Typography
          variant="inherit"
          className="font-bold capitalize"
          color="primary"
          align="right"
          component="p"
        >
          Name
        </Typography>
        <div className="col-span-3">
          <InputField
            id="name"
            name="name"
            value={form.name}
            onChange={(e) => onChange("name", e.target.value)}
          />
        </div>
        <Typography
          variant="inherit"
          className="font-bold capitalize"
          color="primary"
          align="right"
          component="p"
        >
          Year
        </Typography>
        <div className="col-span-3">
          <InputField
            id="year"
            name="year"
            value={form.year}
            onChange={(e) => onChange("year", e.target.value)}
          />
        </div>
        <Typography
          variant="inherit"
          className="font-bold capitalize"
          color="primary"
          align="right"
          component="p"
        >
          Period
        </Typography>
        <div className="col-span-3">
          <SelectPeriod
            id="period"
            name="period"
            value={form.periodId}
            onChange={(e) => onChange("period", e.target.value)}
            placeholder={'Select a period'}
          />
        </div>
        <Typography
          variant="inherit"
          className="font-bold capitalize"
          color="primary"
          align="right"
          component="p"
        >
          Status
        </Typography>
        <div className="col-span-3">
          <SelectField
            id="status"
            name="status"
            value={form.status}
            placeholder={'Select status'}
            options={[
              { value: 'draft', label: 'Draft' },
              { value: 'open-for-marking', label: 'Open for marking' },
              { value: 'open-for-review', label: 'Open for review' },
              { value: 'closed', label: 'Closed' }
            ]}
            onChange={(e) => onChange("status", e.target.value)}
          />
        </div>
      </Box>
    </DialogConfirmCancel>
  );
};

export default FilterDialog;
